import R from 'ramda';
import { createReducer } from 'ha/myredux/createReducer';
import { Actions } from '../constants';

export const initialState = {
  error: false,
  loaded: false,
  loading: false,
};

export default createReducer(
  {
    [Actions.LOAD_START]: state => ({
      ...state,
      loading: true,
    }),
    [Actions.LOAD_DONE]: state => ({
      ...state,
      loading: false,
      error: false,
      loaded: true,
    }),
    [Actions.LOAD_FAIL]: state => ({
      ...state,
      loading: false,
      error: true,
    }),
  },
  initialState,
);

export const getError = R.prop('error');
export const getIsLoaded = R.prop('loaded');
export const getIsLoading = R.prop('loading');
